<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">ОКАТО</div>
            <div class="dx-field-value">
                <ai-text-box :value="data.okato" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBox from '@/components/ai-text-box.vue';

const data = inject('serverData');
</script>
